webpackJsonp([4],{

/***/ 13:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addMissingHTTP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return splitFirstParagraph; });

var beginsWithHTTP = /^https?:\/\//i;

function addMissingHTTP(url) {
  var urlString = String(url).trim();
  if (urlString.length === 0 || urlString[0] === '/' || beginsWithHTTP.test(urlString)) {
    return urlString;
  }
  return 'http://' + urlString;
}

function splitFirstParagraph(htmlString) {
  var regexBr = /<br\s*\/?>\s*<br\s*\/?>/i;
  var regexP = /<\/p>/i;
  var matchBr = regexBr.exec(htmlString);
  var matchP = regexP.exec(htmlString);
  if (matchBr && matchP) {
    if (matchBr.index < matchP.index) {
      matchP = null;
    } else {
      matchBr = null;
    }
  }
  if (matchBr) {
    var opis = htmlString.slice(0, matchBr.index);
    var opis2 = '<p>' + htmlString.slice(matchBr.index + matchBr[0].length);
    if (opis2.length > 100) {
      return [opis, opis2];
    }
  } else if (matchP) {
    var _opis = htmlString.slice(0, matchP.index + matchP[0].length);
    var _opis2 = '' + htmlString.slice(matchP.index);
    if (_opis2.length > 100) {
      return [_opis, _opis2];
    }
  }
  return [htmlString];
}



/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(18)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ 18:
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchDropdown_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea91c3ca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchDropdown_vue__ = __webpack_require__(39);
function injectStyle (ssrContext) {
  __webpack_require__(36)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea91c3ca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(37);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(14)("19ed656e", content, true, {});

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(13)(undefined);
// imports


// module
exports.push([module.i, "@-webkit-keyframes linkUnderlineAnimation{0%{background-size:100% 100%,0 100%}25%{background-size:50% 100%,0 100%}50%{background-size:0 100%,0 100%}75%{background-size:0 100%,50% 100%}to{background-size:0 100%,100% 100%}}@keyframes linkUnderlineAnimation{0%{background-size:100% 100%,0 100%}25%{background-size:50% 100%,0 100%}50%{background-size:0 100%,0 100%}75%{background-size:0 100%,50% 100%}to{background-size:0 100%,100% 100%}}.search-dropdown{border:1px solid #88acc3;position:relative}.search-dropdown:after{content:\"\";pointer-events:none;right:10px;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMinYMid' viewBox='0 0 32 32'%3E%3Cpath d='M21.3 29.4L7.9 16 21.3 2.6l2.8 2.8L13.5 16l10.6 10.6z' fill='%2388acc3'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:50%;background-size:auto 20px;-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.search-dropdown-clear,.search-dropdown:after{width:20px;height:20px;position:absolute;top:calc(50% - 10px)}.search-dropdown-clear{font-size:25px;line-height:20px;cursor:pointer;color:#88acc3;text-align:center;right:36px}.search-dropdown-input{background:#fff;border:none;font-size:.875rem;line-height:17px;outline:none;padding:8px 56px 8px 12px;width:100%}.search-dropdown-input::-webkit-input-placeholder{color:#000}.search-dropdown-input::-moz-placeholder{color:#000}.search-dropdown-input::-ms-input-placeholder{color:#000}.search-dropdown-input::placeholder{color:#000}.search-dropdown-options{background:#fff;border-left:1px solid #88acc3;border-bottom:1px solid #88acc3;border-right:1px solid #88acc3;display:none;position:absolute;left:-1px;top:34px;width:calc(100% + 2px);max-height:230px;list-style:none;margin:0;padding:0;overflow-y:auto;z-index:3}.search-dropdown-options.visible{display:block}.search-dropdown-options li{cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:.875rem;height:23px;line-height:23px;padding:0 12px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.search-dropdown-options li.search-dropdown-group-label{background:#ededed;cursor:default;text-transform:uppercase}.search-dropdown-options li.focused{background:#f3f7f9}.search-dropdown-options li.selected{background-color:#88acc3;color:#fff}.search-dropdown-options li.selected.focused{background-color:#e7eef3}.search-dropdown-options li:not(:last-of-type):not(.selected):after{content:\"\";background-color:#e7eef3;height:1px;width:calc(100% - 24px);position:absolute;left:12px;bottom:0}.search-dropdown-options li .search-dropdown-label{-webkit-box-flex:1;-ms-flex:1 1;flex:1 1;margin-right:4px;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}.search-dropdown ::-webkit-scrollbar{width:4px;height:4px}.search-dropdown ::-webkit-scrollbar-track{background:#b0c8d8;border-radius:0}.search-dropdown ::-webkit-scrollbar-thumb{background:#5a84a0;border-radius:0}", ""]);

// exports


/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ITEM_HEIGHT = 23;
var ITEM_COUNT = 10;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      filter: '',
      active: false,
      focused: -1
    };
  },
  watch: {
    filter: function filter() {
      this.focus(this.focused);
    }
  },
  computed: {
    filteredItems: function filteredItems() {
      var _this = this;

      var filterAndSort = function filterAndSort(items) {
        return items.filter(function (item) {
          return item.selected || item.label.toLowerCase().indexOf(_this.filter.toLowerCase()) > -1;
        }).map(function (item, index) {
          // eslint-disable-next-line no-param-reassign
          item.sortIndex = index;
          return item;
        }).sort(function (a, b) {
          if (!_this.single) {
            if (_this.alphabetise && Boolean(a.selected) === Boolean(b.selected)) {
              return a.label.localeCompare(b.label, 'sl');
            }
            if (a.selected && !b.selected) return -1;else if (!a.selected && b.selected) return 1;
          }
          if (a.sortIndex < b.sortIndex) return -1;else if (a.sortIndex > b.sortIndex) return 1;
          return 0;
        }).map(function (item) {
          // eslint-disable-next-line no-param-reassign
          delete item.sortIndex;
          return item;
        });
      };
      if (this.groups) {
        return this.groups.map(function (group) {
          var itemsFromGroup = filterAndSort(_this.items.filter(function (item) {
            return group.items.indexOf(item.id) > -1;
          }));
          itemsFromGroup.forEach(function (item, index) {
            // eslint-disable-next-line no-param-reassign
            item.groupLabel = index === 0 ? group.label : null;
          });
          return itemsFromGroup;
        }).reduce(function (a, b) {
          return a.concat(b);
        }, []);
      }
      return filterAndSort(this.items);
    },
    selectedIds: function selectedIds() {
      return this.filteredItems.filter(function (item) {
        return item.selected;
      }).map(function (item) {
        return item.id;
      });
    },
    adjustedPlaceholder: function adjustedPlaceholder() {
      if (!this.single) {
        return this.placeholder;
      }
      var selectedItem = this.filteredItems.filter(function (item) {
        return item.selected;
      })[0];
      return selectedItem ? selectedItem.label : this.placeholder;
    }
  },
  directives: {
    clickOutside: {
      bind: function bind(el, binding) {
        var handler = function handler(e) {
          if (!el.contains(e.target) && el !== e.target) {
            binding.value(e);
          }
        };
        el.vueClickOutside = handler; // eslint-disable-line no-param-reassign
        document.addEventListener('click', handler);
      },
      unbind: function unbind(el) {
        document.removeEventListener('click', el.vueClickOutside);
        el.vueClickOutside = null; // eslint-disable-line no-param-reassign
      }
    }
  },
  props: {
    items: { type: Array, required: true },
    placeholder: { type: String, required: true },
    groups: { type: Array, required: false },
    alphabetise: { type: Boolean, required: false, default: true },
    single: { type: Boolean, required: false }
  },
  methods: {
    selectItem: function selectItem(selectedItemId) {
      if (this.single) {
        this.clearSelection();
        this.toggleItem(selectedItemId);
        this.toggleDropdown(false);
        this.$emit('change', this.items.find(function (item) {
          return item.id === selectedItemId;
        }));
      } else {
        this.toggleItem(selectedItemId);
      }
    },
    toggleItem: function toggleItem(itemId) {
      var clickedItem = this.items.filter(function (item) {
        return item.id === itemId;
      })[0];
      this.$set(clickedItem, 'selected', !clickedItem.selected);
    },
    toggleDropdown: function toggleDropdown(state) {
      if (state === false) {
        this.filter = '';
      }
      this.active = state;
    },
    clearSelection: function clearSelection() {
      this.selectedIds.forEach(this.toggleItem);
    },
    focus: function focus(index, withKeyboard) {
      this.focused = Math.max(Math.min(this.filteredItems.length - 1, index), -1);
      if (!withKeyboard) return;
      var additionalOffset = this.filteredItems.slice(0, this.focused + 1).map(function (item) {
        return item.groupLabel ? 1 : 0;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      var optionListEl = this.$el.lastChild;
      var focusedPosition = (this.focused + additionalOffset) * ITEM_HEIGHT;
      if (focusedPosition < optionListEl.scrollTop) {
        optionListEl.scrollTop = focusedPosition;
      } else if (focusedPosition > optionListEl.scrollTop + (ITEM_COUNT - 1) * ITEM_HEIGHT) {
        optionListEl.scrollTop = focusedPosition - (ITEM_COUNT - 1) * ITEM_HEIGHT;
      }
    }
  }
});

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(function() { _vm.toggleDropdown(false) }),expression:"function() { toggleDropdown(false) }"}],staticClass:"search-dropdown"},[(_vm.selectedIds.length > 0)?_c('div',{staticClass:"search-dropdown-clear",on:{"click":_vm.clearSelection}},[_vm._v("×")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"search-dropdown-input",attrs:{"type":"text","placeholder":_vm.adjustedPlaceholder},domProps:{"value":(_vm.filter)},on:{"focus":function($event){_vm.toggleDropdown(true)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.focused !== -1 && _vm.selectItem(_vm.filteredItems[_vm.focused].id)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.preventDefault();_vm.toggleDropdown(true), _vm.focus(_vm.focused - 1, true)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.preventDefault();_vm.toggleDropdown(true), _vm.focus(_vm.focused + 1, true)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key)){ return null; }_vm.toggleDropdown(false)}],"input":[function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value},function($event){_vm.toggleDropdown(true)}]}}),_vm._v(" "),_c('ul',{class:['search-dropdown-options', { visible: this.active }],on:{"mouseleave":function($event){_vm.focus(-1)}}},[_vm._l((_vm.filteredItems),function(item, index){return [(item.groupLabel)?_c('li',{staticClass:"search-dropdown-group-label"},[_vm._v("\n        "+_vm._s(item.groupLabel)+"\n      ")]):_vm._e(),_vm._v(" "),_c('li',{class:{ selected : item.selected, focused : _vm.focused === index },on:{"click":function($event){_vm.selectItem(item.id)},"mouseenter":function($event){_vm.focus(index)}}},[_c('div',{staticClass:"search-dropdown-label"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),(item.count)?_c('div',[_vm._v(_vm._s(item.count))]):_vm._e()])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(418);



var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

window.app = app;

/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c2265b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(420);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c2265b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SearchDropdown_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(138);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var qs = __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(window.location.search);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {
    var _this = this;

    if (this.coverOpen || this.showRegisterModal) {
      var scroller = document.scrollingElement || document.documentElement;
      scroller.style.overflow = 'hidden';
    }
    this.locationChange(window.location);
    window.addEventListener('popstate', function () {
      _this.locationChange(window.location);
    });
  },
  data: function data() {
    return {
      tabs: [{ id: 0, label: 'search ngos', link: '/ngo-partnership/' }, { id: 1, label: 'create your profile', link: '/ngo-partnership/signup/' }],
      filterCountries: [{ id: 0, label: 'Albania', selected: false }, { id: 1, label: 'Austria', selected: false }, { id: 2, label: 'Azerbaijan', selected: false }, { id: 3, label: 'Belarus', selected: false }, { id: 4, label: 'Belgium', selected: false }, { id: 5, label: 'Bosnia and Herzegovina', selected: false }, { id: 6, label: 'Bulgaria', selected: false }, { id: 7, label: 'Croatia', selected: false }, { id: 8, label: 'Cyprus', selected: false }, { id: 9, label: 'Czech Republic', selected: false }, { id: 10, label: 'Denmark', selected: false }, { id: 11, label: 'England', selected: false }, { id: 12, label: 'Estonia', selected: false }, { id: 13, label: 'Finland', selected: false }, { id: 14, label: 'France', selected: false }, { id: 15, label: 'Georgia', selected: false }, { id: 16, label: 'Germany', selected: false }, { id: 17, label: 'Greece', selected: false }, { id: 18, label: 'Hungary', selected: false }, { id: 19, label: 'Iceland', selected: false }, { id: 20, label: 'Ireland', selected: false }, { id: 21, label: 'Italy', selected: false }, { id: 22, label: 'Kosovo', selected: false }, { id: 23, label: 'Latvia', selected: false }, { id: 24, label: 'Liechtenstein', selected: false }, { id: 25, label: 'Lithuania', selected: false }, { id: 26, label: 'Luxembourg', selected: false }, { id: 27, label: 'Macedonia', selected: false }, { id: 28, label: 'Malta', selected: false }, { id: 29, label: 'Moldova', selected: false }, { id: 30, label: 'Montenegro', selected: false }, { id: 31, label: 'Netherlands', selected: false }, { id: 32, label: 'Norway', selected: false }, { id: 33, label: 'Northern Ireland', selected: false }, { id: 34, label: 'Poland', selected: false }, { id: 35, label: 'Portugal', selected: false }, { id: 36, label: 'Romania', selected: false }, { id: 37, label: 'Russia', selected: false }, { id: 38, label: 'Serbia', selected: false }, { id: 39, label: 'Scotland', selected: false }, { id: 40, label: 'Slovakia', selected: false }, { id: 41, label: 'Slovenia', selected: false }, { id: 42, label: 'Spain', selected: false }, { id: 43, label: 'Sweden', selected: false }, { id: 44, label: 'Switzerland', selected: false }, { id: 45, label: 'Turkey', selected: false }, { id: 46, label: 'Ukraine', selected: false }, { id: 47, label: 'Wales', selected: false }],
      filterArea: [{ id: 0, label: 'Anti-Corruption & Transparency', selected: false }, { id: 1, label: 'Children & Youth', selected: false }, { id: 2, label: 'Civic Education & Political Participation', selected: false }, { id: 3, label: 'Civil Protection & Disaster Relief', selected: false }, { id: 4, label: 'Consumer Protection', selected: false }, { id: 5, label: 'Culture & Art', selected: false }, { id: 6, label: 'Development Cooperation & Humanitarian Aid', selected: false }, { id: 7, label: 'Disability & Independent Living', selected: false }, { id: 8, label: 'Education', selected: false }, { id: 9, label: 'Elderly', selected: false }, { id: 10, label: 'Environment & Animals', selected: false }, { id: 11, label: 'European Integration', selected: false }, { id: 12, label: 'Gender Equality', selected: false }, { id: 13, label: 'Health Care', selected: false }, { id: 14, label: 'HIV/AIDS & Drug Abuse', selected: false }, { id: 15, label: 'Housing & Homelessness', selected: false }, { id: 16, label: 'Human Rights, Democracy & Equal Opportunities', selected: false }, { id: 17, label: 'ICT', selected: false }, { id: 18, label: 'Infrastructure Organization', selected: false }, { id: 19, label: 'LGBTI', selected: false }, { id: 20, label: 'Mental Health', selected: false }, { id: 21, label: 'Science & Technology', selected: false }, { id: 22, label: 'Social Enterprise', selected: false }, { id: 23, label: 'Sports', selected: false }, { id: 24, label: 'Tourism', selected: false }, { id: 25, label: 'Violence Prevention', selected: false }, { id: 26, label: 'Volunteering', selected: false }, { id: 27, label: 'Other', selected: false }],
      filterActivities: [{ id: 0, label: 'Advocacy & Lobbying', selected: false }, { id: 1, label: 'Campaigning, PR & Marketing', selected: false }, { id: 2, label: 'Capacity Building', selected: false }, { id: 3, label: 'Consultancy', selected: false }, { id: 4, label: 'Education & Training', selected: false }, { id: 5, label: 'Fundraising', selected: false }, { id: 6, label: 'ICT', selected: false }, { id: 7, label: 'Information Services', selected: false }, { id: 8, label: 'Media & Publishing', selected: false }, { id: 9, label: 'Research & Analysis', selected: false }, { id: 10, label: 'Social Protection & Welfare Systems', selected: false }, { id: 11, label: 'Think Tank', selected: false }, { id: 12, label: 'Other', selected: false }],
      filterKeyword: '',
      coverOpen: false,
      coverData: null,
      sortKey: null,
      sortReverse: false,
      data_ngos: null,
      showRegisterModal: !!qs.registered,
      activeTab: 0
    };
  },

  computed: {
    filterCountriesSelected: function filterCountriesSelected() {
      return this.filterCountries.filter(function (e) {
        return e.selected;
      }).map(function (e) {
        return e.label;
      });
    },
    filterCountriesPlaceholder: function filterCountriesPlaceholder() {
      var selected = this.filterCountriesSelected.length;
      if (!selected || selected === this.filterCountries.length) {
        return 'All countries';
      }
      return 'Selected countries: ' + selected;
    },
    filterAreaSelected: function filterAreaSelected() {
      return this.filterArea.filter(function (e) {
        return e.selected;
      }).map(function (e) {
        return e.label;
      });
    },
    filterAreaPlaceholder: function filterAreaPlaceholder() {
      var selected = this.filterAreaSelected.length;
      if (!selected || selected === this.filterArea.length) {
        return 'All areas';
      }
      return 'Selected areas: ' + selected;
    },
    filterActivitiesSelected: function filterActivitiesSelected() {
      return this.filterActivities.filter(function (e) {
        return e.selected;
      }).map(function (e) {
        return e.label;
      });
    },
    filterActivitiesPlaceholder: function filterActivitiesPlaceholder() {
      var selected = this.filterActivitiesSelected.length;
      if (!selected || selected === this.filterActivities.length) {
        return 'All activities';
      }
      return 'Selected activities: ' + selected;
    },
    filteredNgos: function filteredNgos() {
      var _this2 = this;

      if (this.data_ngos) {
        var filtered = this.data_ngos;
        if (this.filterCountriesSelected.length > 0 && this.filterCountriesSelected.length !== this.filterCountries.length) {
          filtered = filtered.filter(function (e) {
            if (e.countries) {
              return e.countries.some(function (v) {
                return _this2.filterCountriesSelected.indexOf(v) !== -1;
              });
            }
            return false;
          });
        }
        if (this.filterAreaSelected.length > 0 && this.filterAreaSelected.length !== this.filterArea.length) {
          filtered = filtered.filter(function (e) {
            if (e.areas) {
              return e.areas.some(function (v) {
                return _this2.filterAreaSelected.indexOf(v) !== -1;
              });
            }
            return false;
          });
        }
        if (this.filterActivitiesSelected.length > 0 && this.filterActivitiesSelected.length !== this.filterActivities.length) {
          filtered = filtered.filter(function (e) {
            if (e.activities) {
              return e.activities.some(function (v) {
                return _this2.filterActivitiesSelected.indexOf(v) !== -1;
              });
            }
            return false;
          });
        }
        if (this.filterKeyword.trim()) {
          filtered = filtered.filter(function (e) {
            if (e.name) {
              return e.name.toLowerCase().indexOf(_this2.filterKeyword.toLowerCase()) !== -1;
            }
            return false;
          });
        }
        if (this.sortKey) {
          filtered = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(filtered, [function (o) {
            var val = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(o, _this2.sortKey);
            if (typeof val === 'string') {
              return val.toLowerCase();
            }
            return val;
          }]);
          if (this.sortReverse) {
            filtered = filtered.reverse();
          }
        }
        return filtered;
      }
      return this.data_ngos;
    }
  },
  watch: {
    coverOpen: function coverOpen(value) {
      var scroller = document.scrollingElement || document.documentElement;
      if (value) {
        scroller.style.overflow = 'hidden';
      } else {
        scroller.style.overflow = '';
      }
    },
    showRegisterModal: function showRegisterModal(value) {
      var scroller = document.scrollingElement || document.documentElement;
      if (value) {
        scroller.style.overflow = 'hidden';
      } else {
        scroller.style.overflow = '';
      }
    }
  },
  methods: {
    openCover: function openCover(data) {
      this.coverData = data;
      this.coverOpen = true;
      if ('pushState' in history) {
        history.pushState(null, '', '/ngo-partnership/view/' + data.id + '/' + data.slug);
        this.locationChange(window.location);
      }
    },
    closeCover: function closeCover() {
      this.coverOpen = false;
      if ('pushState' in history) {
        history.pushState(null, '', '/ngo-partnership/');
        this.locationChange(window.location);
      }
    },
    fetchData: function fetchData(url, key) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.getJSON(url).done(function (data) {
        data.forEach(function (e) {
          if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(e.countries)) {
            e.countries = [e.countries];
          }
        });

        _this3[key] = data;
      }).fail(function () {
        var arr = [];
        arr.error = true;
        _this3[key] = arr;
      });
    },
    sortBy: function sortBy(key) {
      if (this.sortKey === key) {
        this.sortReverse = !this.sortReverse;
      } else {
        this.sortKey = key;
        this.sortReverse = false;
      }
    },
    closeRegisterModal: function closeRegisterModal() {
      this.showRegisterModal = false;
    },
    locationChange: function locationChange(loc) {
      var _this4 = this;

      if (loc.pathname === '/ngo-partnership/') {
        if (!this.data_ngos) {
          this.fetchData('/ngo-partnership/getNGOs/', 'data_ngos');
        }
        this.coverOpen = false;
        this.coverData = null;
        if (!this.sortKey) {
          this.sortKey = 'id';
          this.sortReverse = true;
        }
      } else {
        var m = loc.pathname.match(/\/view\/(\d+)\/.*$/);
        if (m && m[1]) {
          var id = parseInt(m[1], 10);
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.getJSON('/ngo-partnership/getNGO/' + id + '/').done(function (data) {
            if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(data.countries)) {
              data.countries = [data.countries];
            }
            if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(data.references)) {
              data.references.forEach(function (ref) {
                if (ref.link) {
                  ref.link = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* addMissingHTTP */])(ref.link);
                }
              });
            }
            if (data.contact && data.contact.website) {
              data.contact.website = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* addMissingHTTP */])(data.contact.website);
            }
            _this4.coverData = data;
            _this4.coverOpen = true;
          });
        }
      }
    }
  },
  directives: {
    externallinks: function externallinks(el) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).find('a[href^="http://"],a[href^="https://"]').attr('target', '_blank');
    },

    sortarrow: {
      bind: function bind(el, binding, vnode) {
        el.sortArrowListener = function () {
          vnode.context.sortBy(binding.value);
        };
        el.addEventListener('click', el.sortArrowListener);
        el.classList.add('sortarrow');
        if (binding.value === vnode.context.sortKey) {
          el.classList.add('sortarrow--active');
          if (vnode.context.sortReverse) {
            el.classList.add('sortarrow--reverse');
          } else {
            el.classList.remove('sortarrow--reverse');
          }
        } else {
          el.classList.remove('sortarrow--active');
          el.classList.remove('sortarrow--reverse');
        }
      },
      update: function update(el, binding, vnode) {
        if (binding.value === vnode.context.sortKey) {
          el.classList.add('sortarrow--active');
          if (vnode.context.sortReverse) {
            el.classList.add('sortarrow--reverse');
          } else {
            el.classList.remove('sortarrow--reverse');
          }
        } else {
          el.classList.remove('sortarrow--active');
          el.classList.remove('sortarrow--reverse');
        }
      },
      unbind: function unbind(el) {
        el.removeEventListener('click', el.sortArrowListener);
        el.sortArrowListener = null;
      }
    }
  },
  components: {
    SearchDropdown: __WEBPACK_IMPORTED_MODULE_3__components_SearchDropdown_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid app app--red"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row tabs-container"},[_c('div',{staticClass:"tabs"},[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:tab.id,class:{ active: _vm.activeTab === index }},[_c('a',{attrs:{"href":tab.link}},[_vm._v(_vm._s(tab.label))]),_vm._v(" "),_c('div',{staticClass:"box__arrow-box"}),_vm._v(" "),_c('div',{staticClass:"box__arrow"})])}))])]),_vm._v(" "),_c('div',{staticClass:"filters clearfix"},[_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterKeyword),expression:"filterKeyword"}],staticClass:"form-control",attrs:{"placeholder":"Filter by name"},domProps:{"value":(_vm.filterKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filterKeyword=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('search-dropdown',{staticClass:"dropdown-filter",attrs:{"items":_vm.filterCountries,"placeholder":_vm.filterCountriesPlaceholder}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('search-dropdown',{staticClass:"dropdown-filter",attrs:{"items":_vm.filterArea,"placeholder":_vm.filterAreaPlaceholder}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('search-dropdown',{staticClass:"dropdown-filter",attrs:{"items":_vm.filterActivities,"placeholder":_vm.filterActivitiesPlaceholder}})],1)]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',[_c('button',{directives:[{name:"sortarrow",rawName:"v-sortarrow",value:('name'),expression:"'name'"}],staticClass:"action"},[_vm._v("ORGANISATION")])]),_vm._v(" "),_c('th',[_c('button',{directives:[{name:"sortarrow",rawName:"v-sortarrow",value:('countries'),expression:"'countries'"}],staticClass:"action"},[_vm._v("COUNTRIES")])]),_vm._v(" "),_c('th',[_c('button',{directives:[{name:"sortarrow",rawName:"v-sortarrow",value:('areas'),expression:"'areas'"}],staticClass:"action"},[_vm._v("AREAS")])])])]),_vm._v(" "),_c('tbody',[(_vm.data_ngos == null)?_c('tr',{staticClass:"no-hover"},[_c('td',{attrs:{"colspan":"3"}},[_vm._v("Loading...")])]):(_vm.data_ngos.error)?_c('tr',{staticClass:"no-hover"},[_c('td',{attrs:{"colspan":"3"}},[_vm._v("Error while loading.")])]):(_vm.filteredNgos && _vm.filteredNgos.length <= 0)?_c('tr',{staticClass:"no-hover"},[_c('td',{attrs:{"colspan":"3"}},[_vm._v("No results.")])]):_vm._l((_vm.filteredNgos),function(ngo){return _c('tr',{key:ngo.id,on:{"click":function($event){$event.preventDefault();_vm.openCover(ngo)}}},[_c('td',{attrs:{"data-label":"ORGANISATION"}},[_vm._v(_vm._s(ngo.name))]),_vm._v(" "),_c('td',{attrs:{"data-label":"COUNTRIES"}},[_vm._v(_vm._s(ngo.countries.join(', ')))]),_vm._v(" "),_c('td',{attrs:{"data-label":"AREAS"}},[_vm._v(_vm._s(ngo.areas.join(', ')))])])})],2)])]),_vm._v(" "),(_vm.coverOpen && _vm.coverData)?_c('div',{staticClass:"content-container-cover"},[_c('div',{staticClass:"container-fluid app app--red"},[_c('div',{staticClass:"app__width-container"},[_c('div',{staticClass:"top-bar clearfix"},[_c('a',{staticClass:"top-bar__close",attrs:{"href":"/ngo-partnership/"},on:{"click":function($event){$event.preventDefault();_vm.closeCover($event)}}},[_vm._v("back to search results")]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"info__title"},[_c('small',[_vm._v("ORGANISATION")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.coverData.name))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('dl',{staticClass:"side-box side-box--bg"},[_c('dt',[_vm._v("Countries")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.coverData.countries && _vm.coverData.countries.join(', ')))]),_vm._v(" "),_c('dt',[_vm._v("Areas covered")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.coverData.areas && _vm.coverData.areas.join(', ')))]),_vm._v(" "),_c('dt',[_vm._v("Activities")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.coverData.activities && _vm.coverData.activities.join(', ')))]),_vm._v(" "),_c('dt',[_vm._v("Function")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.coverData.function && _vm.coverData.function.join(', ')))])]),_vm._v(" "),(_vm.coverData.contact)?_c('dl',{staticClass:"side-box side-box--border"},[_c('dt',[_vm._v("Postal Address")]),_vm._v(" "),_c('dd',[_vm._v("\n                "+_vm._s(_vm.coverData.contact.address)),_c('br'),_vm._v("\n                "+_vm._s(_vm.coverData.contact.zip)+" "+_vm._s(_vm.coverData.contact.city)),_c('br'),_vm._v("\n                "+_vm._s(_vm.coverData.contact.country)+"\n              ")]),_vm._v(" "),_c('dt',[_vm._v("Contact Info")]),_vm._v(" "),_c('dd',[(_vm.coverData.contact.phone)?_c('div',[_vm._v(_vm._s(_vm.coverData.contact.phone))]):_vm._e(),_vm._v(" "),(_vm.coverData.contact.email)?_c('div',[_c('a',{staticClass:"line-ellipsis",attrs:{"href":("mailto:" + (_vm.coverData.contact.email)),"target":"_blank"}},[_vm._v(_vm._s(_vm.coverData.contact.email))])]):_vm._e(),_vm._v(" "),(_vm.coverData.contact.website)?_c('div',[_c('a',{staticClass:"line-ellipsis",attrs:{"href":_vm.coverData.contact.website,"target":"_blank"}},[_vm._v(_vm._s(_vm.coverData.contact.website))])]):_vm._e()]),_vm._v(" "),_c('dt',[_vm._v("Contact People")]),_vm._v(" "),_c('dd',[_vm._l((_vm.coverData.contact.people),function(f){return [_c('div',{key:f},[_vm._v(_vm._s(f))])]})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-8 main-content"},[_c('div',{staticClass:"main-content__full-bg"},[_c('div',{directives:[{name:"externallinks",rawName:"v-externallinks"}],staticClass:"block-paragraph",domProps:{"innerHTML":_vm._s(_vm.coverData.description_short)}})]),_vm._v(" "),_c('div',[(_vm.coverData.description)?[_c('div',{staticClass:"main-content__title"},[_vm._v("Description")]),_vm._v(" "),_c('div',{directives:[{name:"externallinks",rawName:"v-externallinks"}],staticClass:"block-paragraph",domProps:{"innerHTML":_vm._s(_vm.coverData.description)}})]:_vm._e(),_vm._v(" "),(_vm.coverData.references)?[_c('hr'),_vm._v(" "),_c('div',{staticClass:"main-content__title"},[_vm._v("References")]),_vm._v(" "),_c('ul',{staticClass:"main-content__list"},_vm._l((_vm.coverData.references),function(f){return _c('li',{key:f.label},[(f.link && f.link.toLowerCase() !== 'null' && f.link.toLowerCase() !== 'http://null')?_c('a',{attrs:{"href":f.link,"target":"_blank"}},[_vm._v(_vm._s(f.label))]):(f.label && (f.label.indexOf('http://') === 0 || f.label.indexOf('https://') === 0) && f.label.toLowerCase() !== 'null' && f.label.toLowerCase() !== 'http://null')?_c('a',{attrs:{"href":f.label,"target":"_blank"}},[_vm._v(_vm._s(f.label))]):_c('span',{staticClass:"like-link"},[_vm._v(_vm._s(f.label))])])}))]:_vm._e()],2)])])])])]):_vm._e(),_vm._v(" "),(_vm.showRegisterModal)?_c('div',[_c('div',{staticClass:"modal",staticStyle:{"display":"block"},attrs:{"tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){$event.preventDefault();_vm.closeRegisterModal($event)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("Congratulations!")])]),_vm._v(" "),_vm._m(3)])])])]):_vm._e(),_vm._v(" "),(_vm.showRegisterModal)?_c('div',{staticClass:"modal-backdrop fade in"}):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app__title"},[_c('h1',[_c('span',[_vm._v("ngo")]),_vm._v(" partnership")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-offset-1 col-lg-10"},[_c('div',{staticClass:"jumbotron"},[_c('p',[_vm._v("Interested in implementing your project in a partnership with NGOs? This online database of NGOs from all of Europe will help you find the right organisation in just a few steps. Register your organisation and/or search the database for suitable organisations and find your NGO partner today.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"top-bar__title"},[_c('span',[_vm._v("ngo")]),_vm._v(" partnership")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("You have successfuly registered your NGO. Admin link was just sent to the email address you entered in the previous step.  You should keep that e-mail in case you want to edit your profile later on.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(57);
var objectAssign = __webpack_require__(58);
var decodeComponent = __webpack_require__(59);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ })

},[417]);


// WEBPACK FOOTER //
// js/ngopartnership.ab55c9faf29fea7a5191.js